export const LAB_STATUS = {
  PENDING: { value: 'Pending', label: 'รอส่ง', variant: 'warning', color: '#ffc107' },
  SENT: { value: 'Sent', label: 'ส่งงานแล้ว', variant: 'primary', color: '#007bff' },
  RECEIVED: { value: 'Received', label: 'รับงานแล้ว', variant: 'purple', color: '#6f42c1' },
  REVISION: { value: 'Revision', label: 'ส่งงานแก้ไข', variant: 'danger', color: '#dc3545' },
  DELIVERED: { value: 'Delivered', label: 'ให้คนไข้แล้ว', variant: 'success', color: '#28a745' }
};

export const LAB_STATUS_LIST = Object.values(LAB_STATUS);

export const getLabStatusByValue = (value) => {
  if (!value) return { value: null, label: 'ยังไม่ระบุ', variant: 'secondary', color: '#6c757d' };
  return LAB_STATUS_LIST.find(s => s.value === value) || { value: null, label: 'ยังไม่ระบุ', variant: 'secondary', color: '#6c757d' };
};
